import { TOGGLE_STRESS_CHECK_PANEL, START_STRESS_POLLING, STOP_STRESS_POLLING, UPDATE_STRESS_DATA, SET_STRESS_POLLING_ERROR } from './actionTypes';
/**
 * Toggles the visibility of the stress check panel.
 */
export function toggleStressCheckPanel() {
    console.log('toggleStressCheckPanel');
    return {
        type: TOGGLE_STRESS_CHECK_PANEL
    };
}
/**
 * Starts stress data polling.
 */
export function startStressPolling() {
    return {
        type: START_STRESS_POLLING
    };
}
/**
 * Stops stress data polling.
 */
export function stopStressPolling() {
    return {
        type: STOP_STRESS_POLLING
    };
}
/**
 * Updates stress data.
 */
export function updateStressData(stressData) {
    return {
        type: UPDATE_STRESS_DATA,
        payload: stressData
    };
}
/**
 * Sets polling error.
 */
export function setStressPollingError(error) {
    return {
        type: SET_STRESS_POLLING_ERROR,
        payload: error
    };
}
